import React from "react";

/**
 * Compact colored badge for a gift_order workflow_status.
 *
 * Statuses:
 *  - offert  : Offert (en attente d'achat)
 *  - achete  : Acheté (chez le fournisseur)
 *  - stocke  : Stocké (entrepôt Milkado)
 *  - remis   : Remis (à l'hôte)
 *  - livre   : Livré (à l'invité final)
 *  - null    : aucun gift_order encore (ex. cagnotte partielle)
 */
export const GIFT_STATUS_META = {
  offert: { label: "Offert",  bg: "#FCE7F3", fg: "#A60F6E" },
  achete: { label: "Acheté",  bg: "#FFE8D6", fg: "#A04A00" },
  stocke: { label: "Stocké",  bg: "#E0E7FF", fg: "#3730A3" },
  remis:  { label: "Remis",   bg: "#D1FAE5", fg: "#065F46" },
  livre:  { label: "Livré",   bg: "#E8F6E5", fg: "#206F18" },
  bloque: { label: "Bloqué",  bg: "#FEE2E2", fg: "#B91C1C" },
  annule: { label: "Annulé",  bg: "#F3F4F6", fg: "#374151" },
};

export default function GiftStatusPill({ status, size = "sm" }) {
  if (!status) {
    return (
      <span
        data-testid="gift-status-pending"
        className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-widest bg-[#F2E2EC] text-[#5C4664]"
        title="Cagnotte en cours — gift_order pas encore créé"
      >
        En cours
      </span>
    );
  }
  const meta = GIFT_STATUS_META[status] || GIFT_STATUS_META.offert;
  const padding = size === "lg" ? "px-3 py-1 text-xs" : "px-2 py-0.5 text-[10px]";
  return (
    <span
      data-testid={`gift-status-${status}`}
      className={`inline-flex items-center rounded-full font-bold uppercase tracking-widest ${padding}`}
      style={{ backgroundColor: meta.bg, color: meta.fg }}
    >
      {meta.label}
    </span>
  );
}
